import React, {useCallback, useEffect, useState} from 'react';
import {Box} from "@chakra-ui/react";
import PointOfInterestForm from "../component/PointOfInterestForm";
import RefreshBtn from "../component/RefreshBtn";
import {v4 as uuidv4} from 'uuid';
import DialogChoose from "../component/DialogChoose";
import ScrooToTop from "../component/ScrooToTop";
import {reactLocalStorage} from 'reactjs-localstorage';
import {useHistory} from "react-router-dom";

const Lab = (props) => {

    const [_key, setKey] = useState(uuidv4());

    const [titlePopup, setTitlePopup] = useState(null);
    const [messagePopup, setMessagePopup] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [dismissText, setDismissText] = useState(null);
    const [acceptText, setAcceptText] = useState(null);

    const refresh = useCallback(() => {
        setTitlePopup("Desideri svuotare il form?");
        setMessagePopup("Attenzione, svuotare il form è irreversibile. Qualsiasi informazione in esso contenuta non sarà più fruibile");
        setIsPopupOpen(true);
        setDismissText("Non desidero svuotare!");
        setAcceptText("Certo, svuota adesso!");
    }, []);

    let history = useHistory();

    useEffect(()=>{
        const User = reactLocalStorage.getObject('User');
        console.log("Abbiamo trovato un User -> "+User);
        if(!User) history.push('/');
    },[]);


    return (
        <Box {...props?.pageProps}>
            <RefreshBtn onRefresh={refresh}/>
            <PointOfInterestForm
                key={_key}
                onRefresh={() => {
                    setKey(uuidv4());
                }}
            />
            <DialogChoose
                isOpen={isPopupOpen}
                onClose={() => {
                    setIsPopupOpen(false);
                }}
                title={titlePopup}
                message={messagePopup}
                dismissText={dismissText}
                acceptText={acceptText}
                onAccept={() => {
                    setKey(uuidv4());
                }}
                onDismiss={() => {
                    //Potenzialmente non si deve cancellare nada

                }}
            />
            <ScrooToTop/>
        </Box>
    );
};

export default Lab;
